import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import './navbar.css';
import { useShoppingList } from '../deals/shoppinglistcontext';

function Navbar () {
    const [click, setClick] = useState(false);
    const [button, setButton] = useState(true);
    const { shoppingList } = useShoppingList();
    
    const handleClick = () => setClick(!click);
    const closeMobileMenu = () => setClick(false);

    const showButton = () => {
        if(window.innerWidth <= 960) {
            setButton(false);
        } else {
            setButton(true);
        }
    };

    useEffect(() => {
        showButton()
    }, []);

    window.addEventListener('resize', showButton);

    return (
    <>
        <nav className='navbar'>
           <div className='navbar-container'>
                <Link to='/' className='navbar-logo' onClick={closeMobileMenu}>
                    <img src='../images/Pennylogga.png' alt="Penny Logo"></img> 
                    <img className="Pennytext" src="images/Pennytext.png" alt="Penny Text"></img>
                </Link> 
                <div className='menu-icon' onClick={handleClick}>
                    <i className={click ? 'fas fa-times' : 'fas fa-bars'} />
                </div>
                <div className="nav-right">
                    <ul className={click ? 'nav-menu active' : 'nav-menu'}>
                        <li className='nav-item'>
                            <Link to='/deals' className='nav-links' onClick={closeMobileMenu}>
                                Deals
                            </Link>
                        </li>

                        <li className='nav-item'>
                            <Link to='/login' className='nav-links' onClick={closeMobileMenu}>
                                Penny
                            </Link>
                        </li>
                        <li className='nav-item'>
                            <Link to='/aboutus' className='nav-links' onClick={closeMobileMenu}>
                                About Us
                            </Link>
                        </li>
                        <li className='nav-item'>
                            <Link to='/contact' className='nav-links' onClick={closeMobileMenu}>
                                Contact
                            </Link>
                        </li>
                        <li className='nav-item'>
                            <Link to='/download' className='nav-links-mobile' onClick={closeMobileMenu}>
                                App
                            </Link>
                        </li>
                    </ul>
                    <div className="nav-end-items">
                        {button && (
                            <Link to='/download' className='app-button-link'>
                                <button className='navbar-app-button'>App</button>
                            </Link>
                        )}
                        <Link to='/shopping-list' className='nav-links shopping-list-link' onClick={closeMobileMenu}>
                            Shopping List ({shoppingList.length})
                        </Link>
                    </div>
                </div>
           </div>   
        </nav>
    </>
    )
}

export default Navbar